<template>
  <v-container>
    <BaseDialog
      :dialog-title="notificationText"
      :visible="dialogSubmit">
      <template slot="body">
        <v-card-text>
          <p>Отчет успешно сохранен!</p>
          <p>
            Хотите добавить новый отчет или перейти в список отчетов?
          </p>
        </v-card-text>
      </template>
      <template slot="footer">
        <v-btn color="primary"
               dark
               class="mb-2"
               tile
               outlined
               @click="$emit('clearReports')">
          Новый отчет
        </v-btn>
        <v-btn
          class="mb-2"
          color="primary"
          @click="$emit('toReports')">
          Список отчетов
        </v-btn>
      </template>
    </BaseDialog>
    <BaseDialog
      :dialog-title="notificationText"
      :visible="dialogErrorSubmit">
      <template slot="body">
        <v-card-text>
          <p>При сохранении отчета произошла внутренная ошибка!</p>
          <p>
            Пожалуйста, напишите <a target="_blank"
                                    href="mailto:ampleyan@gmail.com?subject=FAR - Ошибка сохранения отчета">ampleyan@gmail
              .com</a> и опишите свои действия.
          </p>
          <p>Спасибо</p>
        </v-card-text>
      </template>
      <template slot="footer">
        <v-btn outlined
               color="teal"
               class="mb-2"
               @click="$emit('update:dialogErrorSubmit',false)">
          Назад
        </v-btn>
        <v-btn
          class="mb-2"
          color="primary"
          @click="$emit('toReports')">
          Список отчетов
        </v-btn>
      </template>
    </BaseDialog>

    <BaseDialog
      :visible="dialogReportDuplicate"
      :dialog-title="error['error']==='duplicate_date'? 'Существующая дата': 'Дубликат отчета!'">
      <template slot="body">
        <v-card-text>
          <p v-if="error['error']==='duplicate_date'">
            Дата отчета <b>({{ isMonth ? shortDateFormat(error['date']) : fullDateFormat(error['date']) }})</b> соответствует уже существующей записи! <br>
            Количество отчетов с такой же датой: <b>{{ error['duplicateCnt'] }}</b>
          </p>
          <p v-else>
            Вы пытаетесь добавить отчет, который является точной копией существующего
          </p>
          <p>Вы действительно хотите продолжить?</p>
        </v-card-text>
      </template>
      <template slot="footer">
        <v-btn color="primary"
               dark
               class="mb-2"
               tile
               outlined
               @click="$emit('update:dialogReportDuplicate',false)">
          Нет
        </v-btn>
        <v-btn
          class="mb-2"
          color="primary"
          @click="$emit('addDuplicate')">
          Да
        </v-btn>
      </template>
    </BaseDialog>

    <BaseDialog
      :visible="dialogEmptyReport"
      dialog-title="Отчет не полностью заполнен!">
      <template slot="body">
        <v-card-text>
          <p>Вы пытаетесь добавить отчет, в котором отсутствуют некоторые данные: </p>
          <template>
            <v-alert :value="true"
                     color="error"
                     outlined>
              <li v-for="item in errorList">
                <template v-if="typeof (item) === 'object'">
                  <span v-for="(val,key) in item">
                    {{ key }}:
                    <v-row v-for="v in val" :key="v" class="offset-3">{{ v }}</v-row>
                  </span>
                </template>
                <template v-else>
                  {{ item }}
                </template>
              </li>
            </v-alert>
          </template>
          <p>Вы действительно хотите продолжить?</p>
        </v-card-text>
      </template>
      <template slot="footer">
        <v-btn color="primary"
               dark
               class="mb-2"
               tile
               outlined
               @click="$emit('update:dialogEmptyReport',false)">
          Нет
        </v-btn>
        <v-btn
          class="mb-2"
          color="primary"
          @click="$emit('checkDuplicates')">
          Да
        </v-btn>
      </template>
    </BaseDialog>
  </v-container>
</template>

<script>
// import {requestOptions} from '../_helpers/auth-header'
import BaseDialog from '../../base/BaseDialog'

export default {
    name: "CommonModals",
    components: {BaseDialog},
    props: {
      dialogReportDuplicate: {
          type: Boolean,
          default: false
    },
        dialogErrorSubmit: {
          type: Boolean,
          default: false
    },
      dialogSubmit: {
          type: Boolean,
          default: false
    },
      dialogEmptyReport: {
          type: Boolean,
          default: false
    },
      error: {
          type: Object,
          default: () => {}
    },
      notificationText: {
          type: String,
          default: 'Отчет успешно сохранен'
    },
      errorList: {
          type: Array,
          default: () => []
    },
      isMonth: {
          type: Boolean,
          default: false
      }
    },

    computed: {


    },
    methods: {

    }

  }
</script>


<style lang="scss" scoped>

  .capitalised-input input {
    text-transform: uppercase !important;
  }

  .hidden-header /deep/ {
    display: none !important;
  }
page-link {
	display: inline-block;
}
page-link {
    font-size: 20px;
    color: #29b3ed;
    font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/reports/new/CommonModals.vue